<template>
    <div class="border-t-2 border-blue-600 mt-2 md:mt-4">
        <div class="tan-control-box">
            <div class="select-title pt-1 pb-1 print:hidden">Select:</div>
            <commodity-selector
                class="w-full sm:w-auto xs:pr-0 xs:pb-1"
                v-model="modelSymbol"
                :groupings="commodities"
                :original="defaultSymbol">
            </commodity-selector>
            <div class="items-center inline-block w-full sm:w-auto mb-3 sm:ml-1 text-center print:hidden">
                <button class="btn btn-sm btn-yellow" @click="updateTable">Show Futures Quotes</button>
            </div>
        </div>

        <div v-if="showTable">
            <div class="flex flex-wrap justify-between mt-4 sm:mt-2">
                <div class="mb-2 sm:mb-0 mt-0 sm:mt-3 text-lg font-medium inline-block">
                    {{ currentSymbol }} Contracts
                </div>
                <div class="ml-auto print:hidden">
                    <dt-flip-charts-button></dt-flip-charts-button>
                </div>
            </div>

            <div class="border-t-2 border-blue-600">
                <div class="table-header">
                    <select-c
                        v-model="modelView"
                        :options="views"
                        label="Period:"
                        wrapper-class="xs:w-full"
                    />
                    <!-- <dt-request-select
                        label="Period:"
                        :emit="true"
                        v-model="modelView"
                        @change="emitRequest"
                        :options="views">
                    </dt-request-select> -->
                </div>
            </div>

            <data-table
                v-if="request"
                :default-columns="columns"
                :default-request="request">

                <template #help-text v-cloak>
                    <div class="gray-box">
                        <p class="text-sm xs:text-xs">
                            Letters at the end of quote:<br>
                            <strong>c</strong> - market has closed for the day, but not yet settled<br>
                            <strong>s</strong> - market has settled
                        </p>
                    </div>
                </template>
            </data-table>
        </div>

        <div v-if="!showTable">
            <alert-box>
                <template #body>
                    Please select a commodity
                </template>
            </alert-box>
        </div>
    </div>
</template>

<script setup>
import { ref, watch, nextTick, onMounted, inject } from 'vue';

const props = defineProps({
    commodities: {
        type: Object,
        required: true
    },
    views: Array,
    defaultSymbol: Object,
    modelValue: {
        type: String,
        default: null,
    },
});

const emit = defineEmits();
const eventBus = inject('eventBus');

const defaultRequest = {
    list: 'futures.contractInRootExcludingCash',
    orderBy: 'contractExpirationDate',
    orderDir: 'asc',
    raw: true,
    meta: 'field.name,field.type'
};

const showTable = ref(true);
const currentSymbol = ref(null);

const modelSymbol = ref(null);
const modelView = ref(null);

const columns = ref(null);
const fields = ref(null);
const request = ref(null);

watch(modelView, () => {
    nextTick(() => {
        emitRequest();
    });
});

// Emit request to DataTable
const emitRequest = () => {
    currentSymbol.value = modelSymbol.value.commodity;
    fields.value = modelView.value.request.fields;
    columns.value = modelView.value.columns;

    request.value = {
        ...defaultRequest,
        fields: fields.value,
        columns: columns.value,
        root: modelSymbol.value.root
    };

    eventBus.emit('requestChanged', request);
};

const updateTable = () => {
    currentSymbol.value = modelSymbol.value.commodity;
    if (!showTable.value) {
        showTable.value = true;
    } else {
        emitRequest();
    }
};
</script>
